<!-- <mat-form-field class="example-full-width">

@if(formControl){

  <input
  matInput
  type="text"
  [matAutocomplete]="autoSelect"
  [formControl]="formControl"
  (input)="filterAutoComplete($event.target.value)"
  [disabled]="disabled"
  [placeholder]="label"
  />
  <mat-autocomplete
  #autoSelect="matAutocomplete"
  (optionSelected)="selectValueAutoEvent($event)"
  [displayWith]="displayLabel"
  >
  <mat-option *ngFor="let option of filteredData" [value]="option">
    {{ option.label }}
  </mat-option>
</mat-autocomplete>
}@else{
   <mat-select [(value)]="value" (valueChange)="fetch(value)" [disabled]="disabled">
      @for (item of data; track $index) {
        <mat-option [value]="item.value">{{item.label}}</mat-option>
      }
    </mat-select>
}
<mat-error *ngIf="errorMessage">
  {{ errorMessage }}
</mat-error>
</mat-form-field> -->

<!-- <mat-form-field class="example-full-width"> -->
  <mat-label>{{ label || 'Seleccione una opción' }}</mat-label>
  <input
    matInput
    type="text"
    [matAutocomplete]="auto"
    [formControl]="myControl"
    [disabled]="disabled"
    [placeholder]="label"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectValueAutoEvent($event)">
    <ng-container *ngFor="let option of filteredData">
      <mat-option [value]="option">{{ option.label || option }}</mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-error *ngIf="errorMessage">
    {{ errorMessage }}
  </mat-error>
<!-- </mat-form-field> -->
